export enum ModalTypes {
    CONFIRM = "CONFIRM",
    DETAILS = "DETAILS",
    INFO = "INFO",
    DOWNLOAD = "DOWNLOAD",
    INFODOWNLOAD = "INFODOWNLOAD",
    HISTORY = "HISTORY",
    FAVRITE = "FAVRITE",
    NOTIFICATION = "NOTIFICATION",
}